import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { Card } from "../components/ui/card";
import { fmtDate } from "../lib/format";
import ExportButtons from "../components/ExportButtons";
import PrintFrame from "../components/PrintFrame";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { Badge } from "../components/ui/badge";

export default function Audit() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then(({ data }) => setRows(data)); }, []);
  return (
    <Layout>
      <PrintFrame title="Audit Log" user={user}>
        <div className="mb-4 flex items-center justify-between no-print">
          <div>
            <h1 className="section-title" data-testid="page-title">{t("nav.audit")}</h1>
            <div className="section-sub">{t("sub.audit")}</div>
          </div>
          <ExportButtons endpoint="/reports/export/audit" filenameBase="audit-log" />
        </div>
        <Card className="p-0 overflow-hidden">
          <div className="overflow-x-auto"><table className="vr-table" data-testid="audit-table">
            <thead><tr><th>Timestamp</th><th>Event</th><th>Entity</th><th>Entity ID</th><th>Actor</th><th>Role</th><th>Details</th></tr></thead>
            <tbody>{rows.map((r, i) => (
              <tr key={r.id || r._id || i}><td>{fmtDate(r.server_timestamp)}</td><td><Badge className="bg-slate-100 border text-slate-800">{r.event}</Badge></td><td>{r.entity}</td><td className="font-mono text-xs">{r.entity_id || "—"}</td><td>{r.actor_name}</td><td className="text-xs">{r.actor_role}</td><td className="text-xs font-mono max-w-md truncate" title={JSON.stringify(r.details)}>{JSON.stringify(r.details)}</td></tr>
            ))}</tbody>
          </table></div>
        </Card>
      </PrintFrame>
    </Layout>
  );
}
